module.exports = __webpack_public_path__ + "static/img/图层35.242da28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层35.png
// module id = ujOT
// module chunks = 0